import { defaultHttpClient } from '../../httpClient';

export const postRedeemCoupon = (couponSno: number) => {
  return defaultHttpClient
    .request<{ coupons_count: number; actions: { type: 'MARKET_FAVORITE' }[] }>(
      {
        method: 'POST',
        url: `/api/v2/coupons/${couponSno}/redeem/`,
      },
    )
    .then(result => result.data);
};
